// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__38tf0","label":"Completed_label__3VT4L"};